
import { defineComponent } from "vue";

import { useRoute } from "vue-router";

import { Race } from "@/interfaces";

import { useFindRaceByName, useFindPilotById } from "@/hooks";

import PilotCard from "@/components/Races/Pilot.vue";

export default defineComponent({
  name: "RaceDashboardView",

  setup() {
    const route = useRoute();

    const race: Race | undefined = useFindRaceByName(`${route.params.name}`);

    return { race, useFindPilotById };
  },
  components: {
    PilotCard,
    // PilotRaceResult,
  },
});
